import React from 'react'
import { Icon } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'

const ErrorBadContact = ({ isBadContact }) => {
  return isBadContact ? (
    <div className="flex text-orange-600 text-15 items-baseline space-x-2 mt-2">
      <Icon className="text-15 font-600">warning</Icon>
      <label>
        <FormattedMessage id="error.form.badContact" />
      </label>
    </div>
  ) : null
}

export default ErrorBadContact
